import type { CSSProperties, FC } from 'react';
import cn from 'classnames';
import styles from './style.module.css';

type BlocksStyle = CSSProperties & {
  '--right-block-width': string;
};

type Props = {
  topBlock: React.ReactNode;
  mainBlock: React.ReactNode;
  middleBlock?: React.ReactNode;
  topBlockClassName?: string;
  rightBlock?: React.ReactNode;
  rightBlockOpen?: boolean;
  reserveRightSpace?: boolean;
  rightBlockWidth?: number;
};

const Blocks: FC<Props> = ({
  topBlock,
  mainBlock,
  middleBlock,
  topBlockClassName,
  rightBlock,
  rightBlockOpen = true,
  reserveRightSpace = false,
  rightBlockWidth = 300,
}: Props) => {
  const hasRightRail = Boolean(rightBlock);
  const shouldPositionRightRail = hasRightRail && reserveRightSpace;
  const shouldOpenRightRail = shouldPositionRightRail && rightBlockOpen;
  const layoutStyle: BlocksStyle = {
    '--right-block-width': `${rightBlockWidth}px`,
  };

  return (
    <div
      className={cn(styles.blocksLayout, {
        [styles.blocksLayoutWithRightRail]: shouldPositionRightRail,
        [styles.blocksLayoutWithOpenRightRail]: shouldOpenRightRail,
      })}
      style={layoutStyle}
    >
      <div className={styles.blocks}>
        <div className={cn(styles.block, styles.topBlock, topBlockClassName)}>
          <div className={styles.topBlockContent}>{topBlock}</div>
        </div>

        {middleBlock && (
          <div className={cn(styles.block, styles.middleBlock)}>
            {middleBlock}
          </div>
        )}

        <div className={cn(styles.block, styles.mainBlock)}>{mainBlock}</div>
      </div>

      {hasRightRail ? (
        <aside
          className={cn(styles.rightBlock, {
            [styles.rightBlockOpen]: rightBlockOpen,
            [styles.rightBlockClosed]: !rightBlockOpen,
          })}
          aria-hidden={!rightBlockOpen}
        >
          {rightBlock}
        </aside>
      ) : null}
    </div>
  );
};

export default Blocks;
